module.exports = __webpack_public_path__ + "img/caffeine_brand_logo.eaa4413f.png";